import React, { memo, useState, useEffect, useRef } from 'react';
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import Notification from 'rc-notification';
import { confirmAlert } from "react-confirm-alert";

import { getOrderBook, executeEditOrder, executeCancelOrder } from '../../helpers/apiOrderHelper';

import { formatNumber_N1, priceToNumber, camelCaseObject } from '../../helpers/utils';

let notification = null;
Notification.newInstance({
    closable: true,
    duration: 3,
    style: {
        'top': 50, 
        right: 20,
        color: '#000',
    }
}, (n) => notification = n);

export default memo(function ODROrderBook(props) {

    const { accTno } = props;

    const ref_AccTno = useRef(null);

    const ref_TransPass = useRef(null);
    const ref_Price = useRef(null);
    const ref_Quantity = useRef(null);

    const [executingOrder, setExecutingOrder] = useState(false); 
    const [orderBook, setOrderBook] = useState([]);
    const timeReloadData = 10;
    const [counter, setCounter] = useState(timeReloadData);
    
    const { t } = useTranslation();
    const language = useSelector(state => state.gShared.language);
    const token = useSelector(state => state.gUser.token);

    //
    const _getOrderBook = () => {
        const _getAccTno = accTno;
        const _objData = {
            ticket: token,
            accTno: _getAccTno,
        }
        //
        getOrderBook(_objData).then(function (res) {
            if(res.status === 200) {
                if(_getAccTno === ref_AccTno.current) {
                    const _data = camelCaseObject(res.data);
                    // console.log(_data);
                    setOrderBook(_data.model);
                }
            }
            else {
                console.log(res);
            }
        })
        .catch(function (err) {
            console.log(err);
        });
    }

    const _setInputPriceValue = (value) => {
        if(ref_Price.current) {
            ref_Price.current.value = value;
        }
        else {
            setTimeout(function() {
                _setInputPriceValue(value);
            }, 250);
        }
    }

    const _setInputQuantityValue = (value) => {
        if(ref_Quantity.current) {
            ref_Quantity.current.value = value;
        }
        else {
            setTimeout(function() {
                _setInputQuantityValue(value);
            }, 250);
        }
    }

    const _setInputTransPassValue = (value) => {
        if(ref_TransPass.current) {
            ref_TransPass.current.value = value;
        }
        else {
            setTimeout(function() {
                _setInputTransPassValue(value);
            }, 250);
        }
    }

    const _handleInputTransPassFocus = () => {
        if(ref_TransPass.current) {
            ref_TransPass.current.removeAttribute('readonly');
        }
    }

    const _handleInputTransPassBlur = () => {
        if(ref_TransPass.current) {
            ref_TransPass.current.setAttribute('readonly', true);
        }
    }

    const _showConfirmCancelOrder = (orderData) => {
        try {
            confirmAlert({
                closeOnEscape: true,
                closeOnClickOutside: true,
                customUI: ({ onClose }) => {
                    return (
                        <div className="react-confirm-alert">
                            <div className="react-confirm-alert-body">
                                <h2 className='text-center'>{t('xacNhanHuyLenh')}</h2>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td style={{width: '30%'}}>{t('taiKhoan')}:</td>
                                            <td><b>{orderData.aFACCTNO}</b></td>
                                        </tr>
                                        <tr>
                                            <td>{t('loaiLenh')}:</td>
                                            <td className={orderData.eXECTYPE === "NB" ? "clr-up" : orderData.eXECTYPE === "NS" ? "clr-down" : ""}>
                                                <b>{(orderData.eXECTYPE === "NB" ? t('mua') : orderData.eXECTYPE === "NS" ? t('ban') : "")}</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>{t('maCK')}:</td>
                                            <td><b>{orderData.sYMBOL}</b></td>
                                        </tr>
                                        <tr>
                                            <td>{t('gia')}:</td>
                                            <td><b>{isNaN(orderData.qUOTEPRICE) ? orderData.qUOTEPRICE : formatNumber_N1(orderData.qUOTEPRICE / 1000)}</b></td>
                                        </tr>
                                        <tr>
                                            <td>{t('khoiLuong')}:</td>
                                            <td><b>{orderData.oRDERQTTY}</b></td>
                                        </tr>
                                        <tr>
                                            <td>{t('matKhauGD')}:</td>
                                            <td>
                                                <input className='input-default' style={{margin: 0, width: '100%'}} type={"password"} readOnly maxLength={20} ref={ref_TransPass} onFocus={_handleInputTransPassFocus} onBlur={_handleInputTransPassBlur} />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div className='text-center' style={{marginTop: 10}}>
                                    <button type='button' className='btn-sv' onClick={() => {
                                        _executeCancelOrder(orderData.oRDERID, onClose);
                                    }}>{t('xacNhan')}</button>
                                    <button type='button' className='btn-ex' onClick={() => {
                                        setExecutingOrder(false);
                                        onClose();
                                    }}>{t('huy')}</button>
                                </div>
                            </div>
                        </div>
                    )
                }
            });
        } catch (error) {
            console.log(error);
        }
    }

    const _executeCancelOrder = (orderId, callback) => {
        if(executingOrder) {
            return;
        }
        setExecutingOrder(true);

        try {
            executeCancelOrder({
                ticket: token,
                orderId: orderId,
                passTransfer: ref_TransPass.current?.value ?? "",
            }).then(function (res) {
                if(res.status === 200) {
                    const _data = camelCaseObject(res.data);
                    if(_data.code === 0) {
                        notification.notice({
                            content: t('huyLenhThanhCong'),
                            style: {
                                color: 'green',
                            }
                        });
                        //
                        _getOrderBook();
                        if(callback) {
                            callback();
                        }
                    }
                    else {
                        notification.notice({
                            content: <span>{_data.msg}</span>,
                            style: {
                                color: 'red',
                            }
                        });
                    }
                }
                else {
                    console.log(res);
                }
                //
                setExecutingOrder(false);
            })
            .catch(function (err) {
                setExecutingOrder(false);
                if(callback) {
                    callback();
                }
                console.log(err);
                notification.notice({
                    content: 'Có lỗi xảy ra',
                    style: {
                        color: 'red',
                    }
                });
            });          
        } catch (error) {
            console.log(error);
            setExecutingOrder(false);
            if(callback) {
                callback();
            }
        }
    }

    const _showConfirmEditOrder = (orderData) => {
        try {

            _setInputPriceValue(orderData.qUOTEPRICE/1000);
            _setInputQuantityValue(orderData.oRDERQTTY);
            if(orderData.passTransfer) {
                _setInputTransPassValue(orderData.passTransfer);
            }

            confirmAlert({
                closeOnEscape: true,
                closeOnClickOutside: true,
                customUI: ({ onClose }) => {
                    return (
                        <div className="react-confirm-alert">
                            <div className="react-confirm-alert-body">
                                <h2 className='text-center'>{t('xacNhanSuaLenh')}</h2>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td style={{width: '30%'}}>{t('taiKhoan')}:</td>
                                            <td><b>{orderData.aFACCTNO}</b></td>
                                        </tr>
                                        <tr>
                                            <td>{t('loaiLenh')}:</td>
                                            <td className={orderData.eXECTYPE === "NB" ? "clr-up" : orderData.eXECTYPE === "NS" ? "clr-down" : ""}>
                                                <b>{(orderData.eXECTYPE === "NB" ? t('mua') : orderData.eXECTYPE === "NS" ? t('ban') : "")}</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>{t('maCK')}:</td>
                                            <td><b>{orderData.sYMBOL}</b></td>
                                        </tr>
                                        <tr>
                                            <td>{t('gia')}:</td>
                                            <td>
                                                <input className='input-default' style={{margin: 0, width: '100%'}} type={"text"} maxLength={20} ref={ref_Price} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>{t('khoiLuong')}:</td>
                                            <td>
                                                <input className='input-default' style={{margin: 0, width: '100%'}} type={"text"} maxLength={20} ref={ref_Quantity} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>{t('matKhauGD')}:</td>
                                            <td>
                                                <input className='input-default' style={{margin: 0, width: '100%'}} type={"password"} readOnly maxLength={20} ref={ref_TransPass} onFocus={_handleInputTransPassFocus} onBlur={_handleInputTransPassBlur} />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div className='text-center' style={{marginTop: 10}}>
                                    <button type='button' className='btn-sv' onClick={() => {
                                        _executeEditOrder(orderData, onClose, true);
                                    }}>{t('xacNhan')}</button>
                                    <button type='button' className='btn-ex' onClick={() => {
                                        setExecutingOrder(false);
                                        onClose();
                                    }}>{t('huy')}</button>
                                </div>
                            </div>
                        </div>
                    )
                }
            });
        } catch (error) {
            console.log(error);
        }
    }

    const _executeEditOrder = (orderData, callback, showConfirm) => {
        if(showConfirm) {
            orderData.price = ref_Price.current?.value ?? "";
            orderData.quantityNew = ref_Quantity.current?.value ?? "";
            orderData.passTransfer = ref_TransPass.current?.value ?? "";
            confirmAlert({
                closeOnEscape: true,
                closeOnClickOutside: true,
                customUI: ({ onClose }) => {
                    return (
                        <div className="react-confirm-alert">
                            <div className="react-confirm-alert-body">
                                <h3 className='text-center'>{t('xacNhanSuaLenh')}</h3>
                                <div className='text-center' style={{marginTop: 10}}>
                                    <button type='button' className='btn-sv' onClick={() => {
                                        _executeEditOrder(orderData, onClose, false);
                                    }}>{t('xacNhan')}</button>
                                    <button type='button' className='btn-ex' onClick={() => {
                                        onClose();
                                    }}>{t('huy')}</button>
                                </div>
                            </div>
                        </div>
                    )
                }
            });
        }
        else {
            if(executingOrder) {
                return;
            }
            setExecutingOrder(true);

            try {
                executeEditOrder({
                    ticket: token,
                    orderId: orderData.oRDERID,
                    orderType: orderData.eXECTYPE,
                    quantity: orderData.oRDERQTTY,
                    quantityNew: orderData.quantityNew,
                    price: orderData.price,
                    passTransfer: orderData.passTransfer
                }).then(function (res) {
                    if(res.status === 200) {
                        if(callback) {
                            callback();
                        }

                        const _data = camelCaseObject(res.data);
                        if(_data.code === 0) {
                            notification.notice({
                                content: t('suaLenhThanhCong'),
                                style: {
                                    color: 'green',
                                }
                            });
                            //
                            _getOrderBook();
                            if(callback) {
                                callback();
                            }
                        }
                        else {
                            notification.notice({
                                content: <span>{_data.msg}</span>,
                                style: {
                                    color: 'red',
                                }
                            });
                            //
                            _showConfirmEditOrder(orderData);
                        }
                    }
                    else {
                        console.log(res);
                    }
                    //
                    setExecutingOrder(false);
                })
                .catch(function (err) {
                    setExecutingOrder(false);
                    if(callback) {
                        callback();
                    }
                    console.log(err);
                    notification.notice({
                        content: 'Có lỗi xảy ra',
                        style: {
                            color: 'red',
                        }
                    });
                });
            } catch (error) {
                console.log(error);
                setExecutingOrder(false);
                if(callback) {
                    callback();
                }
            }
        }
    }

    //
    useEffect(() => {
        ref_AccTno.current = accTno;
        _getOrderBook();
    }, [accTno]);

    useEffect(() => {
        if(counter <= 0) {
            setCounter(timeReloadData);
            _getOrderBook();
        }
    }, [counter]);

    useEffect(() => {
        const _timerId = setInterval(() => {
            setCounter(o => o-1);
        }, 1000);

        return () => {
            if(_timerId > 0) {
                clearInterval(_timerId);
            }
        }; 
    }, []);
    
    //
    return (
        <table className="table-ck">
            <thead>
                <tr>
                    <th>{t('side')}</th>
                    <th>{t('maCK')}</th>
                    <th className='text-center'>{t('kl')}</th>
                    <th className='text-right'>{t('gia')}</th>
                    <th className='text-right'>{t('trangThai')}</th>
                    <th className='text-right'>{t('chucNang')}</th>
                </tr>
            </thead>
            <tbody>
            {orderBook && orderBook.map((item, index) => {
                // console.log(item);
                
                // aDJUSTQTTY: 0
                // aFACCTNO: "0001001242MG"
                // aFACCTNO_PT_DISPLAY: null
                // aLLOWADJUST: 0
                // aLLOWCANCEL: 0
                // aVGMATCHPRICE: 0
                // bRATIO: 100.3
                // cANCELQTTY: 0
                // cUSTID: "0001001242"
                // cUSTODYCD: "067C001242"
                // eRRDESCRIPTION: null
                // eRRORCODE: null
                // eXECAMT: 0
                // eXECQTTY: 0
                // eXECTYPE: "NB"
                // eXECTYPEDISPLAY: "Mua"
                // eXPDATE: "2021-07-02T00:00:00"
                // eXQTTY: 1000
                // fULLNAME: "NA 01"
                // gIATRILENH: 16000000
                // iSERROR: 0
                // lIMITPRICE: null
                // mATCHPRICE: 0
                // mATCHTYPE: "Thông thường"
                // mATCHTYPE_EN: "Normal"
                // mATCH_TYPE: "N"
                // oDTYPE: "N"
                // oDTYPEDISPLAY: "Thông thường"
                // oDTYPEDISPLAY_EN: "Normal"
                // oODSTATUS: "N"
                // oRDERID: "00012021070238079"
                // oRDERMGSELL: "N"
                // oRDERNUM: null
                // oRDERPLACE: "Công ty cổ phần chứng khoán Toàn Cầu"
                // oRDERQTTY: 1000
                // oRSTATUS: "Mới tạo"
                // oRSTATUSVL: "8"
                // oRSTATUS_EN: "Newly Placed"
                // pRICESTATE: "STOP"
                // pRICETYPE: "LO"
                // pRICETYPEDISPLAY: "Lệnh giới hạn"
                // qUOTEPRICE: "16000"
                // rEFACCTNO: "0001001242MG"
                // rEFACCTNO_PT_DISPLAY: "0001001242MG"
                // rEJECTQTTY: 0
                // rEMAINQTTY: 1000
                // sELLTAX: 0
                // sHORTNAME: "NA"
                // sTT: 1
                // sYMBOL: "AAA"
                // tIME_EXECUTE: null
                // tLNAME: "067C001242"
                // tRADEPLACE: "Hồ Chí Minh"
                // tRADE_PLACE: "001"
                // tXDATE: "2021-07-02T00:00:00"
                // tXNUM: "F000045780"
                // tXTIME: "09:13:08"
                // vIA: "Trực tuyến"
                // vIAVL: "O"
                
                return (
                    <tr key={index}>
                        <td className={item.eXECTYPE === "NB" ? "clr-up" : item.eXECTYPE === "NS" ? "clr-down" : ""}>{(item.eXECTYPE === "NB" ? t('sideMua') : item.eXECTYPE === "NS" ? t('sideBan') : "")}</td>
                        <td>{item.sYMBOL}</td>
                        <td>{formatNumber_N1(item.eXECQTTY)}/{formatNumber_N1(item.oRDERQTTY)}</td>
                        <td>{isNaN(item.qUOTEPRICE) ? item.qUOTEPRICE : formatNumber_N1(item.qUOTEPRICE / 1000)}</td>
                        <td className='break-word'>{language === "en" ? item.oRSTATUS_EN : item.oRSTATUS}</td>
                        <td className='text-center'>
                            {/* {item.aLLOWADJUST && item.aLLOWADJUST === 1 ? (
                                <span className='btn-text clr-up' onClick={() => _showConfirmEditOrder(item)}>Sửa</span>
                            ) : null} */}
                            {/* {item.aLLOWCANCEL && item.aLLOWCANCEL === 1 ? (
                                <span className='btn-text clr-down' onClick={() => _showConfirmCancelOrder(item)}>Hủy</span>
                            ) : null} */}
                            {item.aLLOWADJUST && item.aLLOWADJUST === 1 ? (
                                <span className='btn-icon clr-up' title='Edit' onClick={() => _showConfirmEditOrder(item)}>
                                    <img src="/static/img/icon/icon-edit.svg" alt="img" />
                                </span>
                            ) : null}
                            {item.aLLOWCANCEL && item.aLLOWCANCEL === 1 ? (
                                <span className='btn-icon clr-down' title='Cancel' onClick={() => _showConfirmCancelOrder(item)}>
                                    <img src="/static/img/icon/icon-trash.svg" alt="img" />
                                </span>
                            ) : null}
                        </td>
                    </tr>
                )
            })}
            </tbody>
        </table>
    )
})
